import { useCallback } from "react"
import styles from '../components/Screener.module.scss'
import CompanyDataCell from '../components/CompanyDataCell'
import TickerDataCell from '../components/TickerDataCell'
import WatchlistButton from '../../ui/WatchlistButton'
import { BarChart, MonetizationOnOutlined } from '@mui/icons-material'
import { formatPrice, marketCapFormat, formatDecimal } from '../../../utils/tools'
import ProgressBarWindow from '../../ProgressBarWindow'
import PercentageWithArrow from '../../ui/PercentageWithArrow'
import { Tooltip } from "@mui/material"

const useScreener = (projects, handleOpenProject, projectMethods, checkIfProjectExist) => {

    const datasetFormat = (dataset) => ({ 
        field: `${dataset["datasetName"]} - ${dataset["columnName"]}`, 
        headerName: `${dataset["datasetName"]} - ${dataset["columnName"]}`, 
        renderCell: (params) => <PercentageWithArrow number={params.value.toFixed(2)} makePrecent={false}/>,
        hide: false,
        isDataset: true
    })
    
    const chipsLabels = {
        dataset: 'Alternative Data',
        sector: 'Sector',
        market_cap: 'Market Cap',
        exchange: 'Exchange',
        financial_kpi:'Financial KPI',
        mic_code: 'Mic Code',
        limitsOn:'Top & Bottom'
    }

    const headerWithIcon = (value, icon) => (
        <div className={styles['table-header-icon-format']}>
            {icon}
            <span>{value}</span>
        </div>
    )

    const handleUpdateWatchlist = async (data) => {
        // const project = await handleOpenProject(data.ticker, '', '', false)
        const project = await handleOpenProject(data.id, '', '', false)
        await projectMethods.toggleWatchlist(project['uuid'])
    }
    
    const weekRangeFormat = (params) => {
        const { price, low, high } = params.value ?? {}
        return <Tooltip title={`Price - ${price}`} placement='top' ><div className={styles['week-range-cell']}>
                <ProgressBarWindow precent={price/(high/100)} tag={{'':low}} secondTag={{'':high}}/>
            </div></Tooltip>
    }
    
    const priceFormat = (params) => formatPrice(params.value, 'auto','en-US',params.row.currency_code)

    const watchlistFormat = useCallback((params) => {
        const project = checkIfProjectExist(params.id)
        return <WatchlistButton 
            active={project?.portfolio?.added} 
            // handleClick={handleUpdateWatchlist} 
            handleClick={()=>handleUpdateWatchlist(params.row)} 
            externalClassName={styles['watchlist']} 
            value={{uuid:project?.uuid, ticker:params.id}}
        />
    },[projects]) // eslint-disable-line

    const watchlistField = { field: 'isInWatchlist', headerName: '', width: 10, renderCell: watchlistFormat, disabled: true, hide: false}
    
    const LimtOnField = { field: 'level', headerName: 'Limit Type', hide: false}

    const initColumns = [
        { field: 'symbol', headerName: 'Ticker',  disabled: true, hide: false, renderCell:(params)=><TickerDataCell ticker={params.id} project={params.project} /> },
        { field: 'companyName', headerName: 'Name', renderCell: (params) => <CompanyDataCell ticker={params.id} companyName={params.value} project={params.project}/>, hide: false},
        { field: 'sector', headerName: 'Sector', hide: false },
        { field: 'price', headerName: 'Closing Price', renderCell: priceFormat, hide: false},
        { field: 'market_cap', renderHeader: () => (headerWithIcon('Marketcap', <MonetizationOnOutlined/>)), renderCell: (params) => marketCapFormat(params), hide: false},
        { field: 'volume', renderHeader: () => (headerWithIcon('Volume', <BarChart/>)), renderCell: (params) => formatDecimal(params.value, 'auto'), hide: false},
        { field: '52WeekRange', headerName: '52 Week Range', renderCell: weekRangeFormat, sortComparator: (v1, v2) => v1.price - v2.price, hide: false},
    ]

    return {
        initColumns,
        chipsLabels,
        datasetFormat,
        watchlistField,
        LimtOnField
    }
}

export default useScreener